var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundHalf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 27.593,
    viewBox: "0 0 37.153 27.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Volume-Up",
    "data-name": "Iconly/Light/Volume-Up",
    transform: "translate(0.748 0.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Volume-Up",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M0,13.136C0,15.444-.1,18.591,1.323,19.767c1.332,1.1,2.269.815,4.7.993s7.567,7.331,11.525,5.069c2.042-1.606,2.194-4.972,2.194-12.694S19.59,2.048,17.548.442C13.59-1.821,8.455,5.332,6.023,5.512s-3.368-.1-4.7.993C-.1,7.681,0,10.829,0,13.136Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#464547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    d: "M14.581,3.314a13.883,13.883,0,0,1,0,13.833",
    transform: "translate(12.781 2.905)",
    fill: "none",
    stroke: "#464547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundHalf);
export default __webpack_public_path__ + "static/media/soundHalf.9c3aaf3b436b5989e804fb7774aa3830.svg";
export { ForwardRef as ReactComponent };